// ======================================================================
// File Name       : adaptive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const DISCRIMINATION_DEGREE_DATA = 'DISCRIMINATION_DEGREE_DATA';
export const RECEIVED_ADAPTIVE_META_IMPORT_LIST = 'RECEIVED_ADAPTIVE_META_IMPORT_LIST';
